<template>
  <div v-if="domRenderer" id="app">
    <router-view />
    <!-- loading -->
    <TransitionAm>
      <div v-show="loading" class="loading_dialog">
        <div class="loading_box">
          <img width="150px; height: 150px;" alt="加载动画图" src="~@/assets/images/icon_loading.svg">
          <div v-show="isDownloading" class="load_font_box">
            <p>下载中，请耐心等待</p>
            <div class="load_font_box_footer">
              <p v-report:mainclick="{ area: 'downpage', pos: 0 }" class="btn" @click="clickOutDownLoad">取消下载</p>
              <p v-report:mainclick="{ area: 'downpage', pos: 1 }" class="btn" @click="clickCustomer">联系客服</p>
            </div>
          </div>
        </div>
      </div>
    </TransitionAm>
    <!-- loadingMask -->
    <TransitionAm><div v-show="loadingMask" class="loading_dialog" /></TransitionAm>

    <!-- 下载提示升级会员 -->
    <UpgradeMemberByDownTipDialog />
    <DownErrorTipDialog />
    <!-- 设置弹框 -->
    <Dialog v-model="settingDialogVisible" size="middle" :title="'设置'"><ToolsSetting /></Dialog>
  </div>
</template>

<script>
import TransitionAm from '@/components/TransitionAm/index.vue'
import UpgradeMemberByDownTipDialog from '@/views/common/tipDialog/UpgradeMemberByDownTipDialog.vue'
import DownErrorTipDialog from '@/views/common/tipDialog/DownErrorTipDialog.vue'
import Dialog from '@/components/Dialog/index.vue'
import ToolsSetting from '@/components/Tools/ToolsSetting.vue'

import { getParamsByUrl } from '@shared/utils/base/index.js'
import {
  CacheSessionSetSource, CacheSessionSetChannel, CacheSessionSetProjectType,
  CacheGetDialogPayAbTestType, CacheSetDialogPayAbTestType,
  CacheSessionGetChannel
} from '@/common/cache.js'
import { getProjectSpacialList, getProjectAsideList, getProjectUnshowList, customerServiceUrl } from '@/common/data.js'
import {
  channelType, Projecttype, unshowMap,
  abTestType, projectType, TableKey
} from '@/common/const.js'
import { ClientGetUserInfo, ClientStopDownload, ClientOpenBrowser, ClientGetDBUserInfo, ClientGetIsVip, ClientCloseTable } from '@/api/clientApi.js'

const DefaultProjecttype = 'ppt'

export default {
  name: 'App',

  components: { Dialog, ToolsSetting, TransitionAm, UpgradeMemberByDownTipDialog, DownErrorTipDialog },

  data () {
    return {
      domRenderer: false, // 页面基于分类，所以分类得在页面渲染前获取
      svrId: ''
    }
  },

  computed: {
    userInfo () {
      return this.$store.state.userInfo
    },

    isLoginedIn () {
      return this.$store.getters.isLoginedIn
    },

    isVipForever () {
      return this.$store.getters.isVipForever
    },

    isVip () {
      return this.$store.getters.isVip
    },

    loading () {
      return this.$store.state.loading
    },

    loadingMask () {
      return this.$store.state.loadingMask
    },

    isDownloading () {
      return this.$store.state.isDownloading
    },

    isShowDubaLogin () {
      return this.$store.state.isShowDubaLogin
    },

    settingDialogVisible: {
      get () {
        return this.$store.state.tipsDialog.settingDialogVisible
      },
      set () {
        this.$store.commit('tipsDialog/vuexChangeSettingDialogVisible', false)
      }
    },

    projectType () {
      return this.$store.state.projectType
    },

    isChannelKeniuTools () {
      return this.$store.getters['channel/isChannelKeniuTools']
    },

    isChannelDg () {
      return this.$store.getters['channel/isChannelDg']
    }
  },

  beforeCreate () {
    // source 上报属性优先于其他功能，得与create分割开，以免后期不小心写了优先级更高代码导致上报出错
    const query = getParamsByUrl(location.search)

    if (query.channel !== channelType.duba) { // 非duba渠道没有该功能
      this.$store.commit('unshow/vuexSetPrejectUnshow', [unshowMap.feedback])
    }

    // 一个channel下面可能会有几十个source
    if (query.channel) {
      CacheSessionSetChannel(query.channel) // 渠道功能，目前涉及：首页副标题
    }
    if (query.source) {
      CacheSessionSetSource(query.source)
    }

    // projecttype可能没有，默认是ppt，ppt的时候就没有
    const projectType = query[Projecttype] || DefaultProjecttype // channel、source可以没有projecttype一定得有

    CacheSessionSetProjectType(projectType)

    this.$store.commit('vuexChangeProjectType', projectType)
    this.$store.commit('unshow/vuexSetPrejectUnshow', getProjectUnshowList(projectType))
    this.$store.commit('vuexSetElementIndex', getProjectSpacialList(projectType))
    this.$store.dispatch('home/vuexSetAsideList', getProjectAsideList(projectType))
  },

  async created () {
    await Promise.all([
      this.setSvrid(),
      this.setTrynoToVuex()
    ])
    this.setChannelToVuex()
    this.setUserInfoToVuex()
    await this.initAbTest()
    await Promise.all([
      this.initStateDubaVip(),
      this.$store.dispatch('operational/getCategory')
    ])
    this.domRenderer = true
  },

  methods: {
    async setTrynoToVuex () {
      const tryno = await this.getTryno()
      this.$store.commit('channel/vuexChangeTryno', tryno)
    },

    getTryno () {
      return new Promise(resolve => {
        ClientGetDBUserInfo((res) => {
          const tryno = res?.tryno
          resolve(tryno)
        }, () => {
          resolve(null)
        })
      })
    },

    setSvrid () {
      return new Promise(resolve => {
        ClientGetDBUserInfo((res) => {
          const svrId = res?.svrid
          this.svrId = svrId
          resolve(svrId)
        }, () => {
          resolve('')
        })
      })
    },

    setUserInfoToVuex (fn) {
      ClientGetUserInfo((userInfo) => {
        this.$store.commit('vuexSetUserInfo', userInfo)
        if (this.isLoginedIn) {
          this.hasUserInfoCache = true
          this.$store.dispatch('home/vuexGetUserCollectIdList')
        }
        fn()
      })
    },

    clickOutDownLoad () {
      ClientStopDownload()
    },

    clickCustomer () {
      ClientOpenBrowser(customerServiceUrl)
    },

    updateDialogPayAbTestType () {
      const cache = CacheGetDialogPayAbTestType()
      if (cache) {
        // this.$store.commit('vuexChangePayAbTestType', cache.type)
        const type = abTestType.b
        this.$store.commit('vuexChangePayAbTestType', type)
      } else {
        this.setDialogPayAbTestType()
      }
    },

    updateIsUseNewChanAbTest () {
      this.$store.dispatch('abTest/updateIsUseNewChan')
    },

    setDialogPayAbTestType () {
      const isLessThanHalf = Math.random() < 0.5
      const type = isLessThanHalf ? abTestType.a : abTestType.b
      CacheSetDialogPayAbTestType(type)
      this.$store.commit('vuexChangePayAbTestType', type)
    },

    setHomeNumberCol (numberCol) {
      this.$store.commit('home/vuexChangeHomeNumberCol', numberCol)
    },

    updateHomeNumberCol () {
      if (this.projectType === projectType.ppt) {
        this.setHomeNumberCol(1)
      } else {
        this.setHomeNumberCol(2)
      }
    },

    setChannelToVuex () {
      const channel = CacheSessionGetChannel()
      this.$store.commit('channel/vuexChangeChannel', channel)
    },

    initStateDubaVip () {
      return new Promise((resolve, reject) => {
        if (this.isChannelKeniuTools) {
          const isDubaVip = false
          this.$store.commit('vuexChangeIsDubaVip', isDubaVip)
          resolve(isDubaVip)
          return
        }
        ClientGetIsVip((res) => {
          const isDubaVip = res?.result || false
          this.$store.commit('vuexChangeIsDubaVip', isDubaVip)
          resolve(isDubaVip)
        })
      })
    },

    initAbTest () {
      this.updateDialogPayAbTestType()
      this.updateHomeNumberCol()
      this.updateIsUseNewChanAbTest()
    },

    closeDialogPay () {
      ClientCloseTable(TableKey.buyTable)
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/global.scss';

@keyframes round {
  0% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(90deg);
  }
  50% {
    transform: rotate(180deg);
  }
  75% {
    transform: rotate(270deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
html { overflow: hidden; } // 收起时使用
#app {
  position: relative;
  box-sizing: border-box;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  font-family: 思源黑体, 思源宋体, Avenir, Helvetica, Arial, sans-serif;
  color: $font_color;
  background-color: $bg;

  .loading_dialog {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 100;
    background-color: $font_color_5;

    .loading_box { position: absolute; top: 50%; left: 50%; display: flex; flex-direction: column; align-items: center; justify-content: center; width: 100%; transform: translate(-50%, -50%); }
    img { animation-name: round; animation-duration: 2s; animation-timing-function: linear; animation-iteration-count: infinite; }

    .load_font_box { display: flex; flex-direction: column; align-items: center; justify-content: center; font-weight: bold; color: #fff;
      .load_font_box_footer { display: flex; justify-content: center; margin-top: 20px;
        .btn {
          text-decoration: underline; cursor: pointer;
          &:hover { color: #f7be0c; }
        }
        .btn:last-child {
          margin-left: 10px;
        }
      }
    }
  }
}
</style>
